import { TranslateService } from 'shared';


export class AgGridProjectUsersSettings {

  constructor(private translate: TranslateService) { }

  public agGridProjectUsersSettings = {
    rowModelType: 'infinite' as any,
    //virtualPaging: true,
    //enableServerSideSorting: true,
    //enableServerSideFilter: true,
    rowSelection: { mode: 'singleRow', checkboxes: false } as any,
    //rowDeselection: true,
    rowHeight: 55,
    cacheBlockSize: 10000,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 1,
    paginationPageSize: 30,
    infiniteInitialRowCount: 1,
    columnDefs: [
      { field: 'userName', headerName: `${this.translate.data["PROJECTUSERSCOLUMNHEADER"]}`, cellStyle: { color: '#303f6f' }, sortable: true, filter: true },
      {
        headerName: `${this.translate.data["PROJECTUSERSACTIONSCOLUMNHEADER"]}`,
        cellStyle: { color: '#303f6f' },
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          icon_view: 'remove_red_eye',
        }
      },
    ],
    defaultColDef: {
      flex: 1,
      resizable: true,
      minWidth: 100,
      editable: false
    }
  }
}